import React from 'react';
import { classNames } from '../../../Services/helpers';

const Card = ({children, noPadding = false}) => {

    return <div className={classNames(
        'w-full rounded-lg surface-1 surface-outline shadow-lg',
        noPadding ? null : 'p-5',
    )}>
        {children}
    </div>;
};

export default Card;
